import { useQuery } from '@tanstack/react-query'
import { elencaScadenze } from '../scadenze/scadenze.api'
import { caricaSogliaPartner, elencaImpiantiGreen } from '../green/green.api'
import { elencaDichiarazioni, terminiDichiarazioni } from '../dichiarazione/dichiarazione.api'
import { ANNO_IMPOSTA } from '../lib/anno-imposta'

const NESSUNA = [] as const

/**
 * Scadenze e produzione con le stesse chiavi di Scadenzario e Controllo: menu, cruscotto e
 * scheda impianto condividono la cache. Una lettura che fallisce (permesso, RLS) vale vuota:
 * il cruscotto non deve mai diventare una schermata di errore.
 */
export function useDatiQuadro(idPartner: number, attivi = { scadenze: true, produzione: true, dichiarazioni: true }) {
  const { data: scadenze = NESSUNA } = useQuery({
    queryKey: ['scadenze'],
    queryFn: elencaScadenze,
    retry: false,
    enabled: attivi.scadenze,
  })
  const { data: green = NESSUNA } = useQuery({
    queryKey: ['impianti-green'],
    queryFn: elencaImpiantiGreen,
    retry: false,
    enabled: attivi.produzione,
  })
  // Stesso valore di riserva di Controllo quando la soglia del partner non si legge.
  const { data: soglia = '20' } = useQuery({
    queryKey: ['soglia-partner', idPartner],
    queryFn: () => caricaSogliaPartner(idPartner),
    retry: false,
    enabled: attivi.produzione,
  })
  const { data: termini = {} } = useQuery({
    queryKey: ['termini-dichiarazioni', ANNO_IMPOSTA],
    queryFn: () => terminiDichiarazioni(ANNO_IMPOSTA),
    retry: false,
    staleTime: Infinity,
  })
  const { data: dichiarazioni = NESSUNA } = useQuery({
    queryKey: ['dichiarazioni-anno', ANNO_IMPOSTA],
    queryFn: () => elencaDichiarazioni(ANNO_IMPOSTA),
    retry: false,
    enabled: attivi.dichiarazioni,
  })
  return { scadenze, green, soglia, termini, dichiarazioni }
}
